'use client'

import { Spacer, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useSession } from '@marketplace-web/shared/session-data'

import SignUpButton from '../../../components/SignUpButton/SignUpButton'
import ConvertButton from '../../../components/ConvertButton/ConvertButton'

const Hero = () => {
  const translate = useTranslate('business.homepage')
  const { user } = useSession()
  const isUserLoggedIn = !!user

  return (
    <div className="business-accounts-homepage__hero">
      <div className="business-accounts-homepage__hero-container">
        <div className="u-desktops-only">
          <div className="business-accounts-homepage__hero-heading-container">
            <div className="business-accounts-homepage__hero-heading">
              <Text as="span" width="parent" html>
                <span className="c-text--responsive-large-heading c-text--inverse">
                  {isUserLoggedIn
                    ? translate('hero.title.logged_in')
                    : translate('hero.title.logged_out')}
                </span>
              </Text>
              <Spacer size="x2-large" />
              <Text as="span" width="parent">
                <span className="c-text--responsive-large-body c-text--inverse">
                  {isUserLoggedIn
                    ? translate('hero.subtitle.logged_in')
                    : translate('hero.subtitle.logged_out')}
                </span>
              </Text>
              <Spacer size="x3-large" />
              <div className="business-accounts-homepage__cta">
                {isUserLoggedIn ? (
                  <ConvertButton text={translate('actions.convert_account')} />
                ) : (
                  <SignUpButton text={translate('actions.sign_up')} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Hero
